import React, {
  useImperativeHandle,
  forwardRef,
  useRef,
  useState,
  useEffect,
} from "react";
import styles from "./styles.module.css";

const DialogWinLose = forwardRef(({}, ref) => {
  const dialogRef = useRef(null);
  const [toastMessage, setToastMessage] = useState("");

  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  useImperativeHandle(ref, () => ({
    openDialog: async (message = "", delay = 0, mode = 0) => {
      if (delay > 0) {
        await sleep(delay);
      }

      if (message != "") {
        setToastMessage(message);
      }

      const element = dialogRef.current;
      if (element) {
        element.classList.remove(styles.dialogViewClose);
        element.classList.remove(styles.dialogViewHide);
        element.classList.add(styles.dialogViewActive);
      }
    },
  }));

  const closeDialog = () => {
    const element = dialogRef.current;
    if (element && element.classList.contains(styles.dialogViewActive)) {
      element.classList.remove(styles.dialogViewActive);
      element.classList.remove(styles.dialogViewClose);
      element.classList.add(styles.dialogViewHide);
    }
  };

  const onAnimationEnd = () => {
    const element = dialogRef.current;
    if (element && element.classList.contains(styles.dialogViewHide)) {
      element.classList.remove(styles.dialogViewActive);
      element.classList.remove(styles.dialogViewHide);
      element.classList.add(styles.dialogViewClose);
    }
  };

  return (
    <div
      className={[styles.dialogView, styles.dialogViewClose].join(" ")}
      onAnimationEnd={onAnimationEnd}
      ref={dialogRef}
    >
      <div className={[styles.dialogContentsView]}>
        <div className={[styles.dialogContents]}>
          <img src={require("../../media/icons/check_icon.png")} />
          <div className={[styles.dialogTitle]}>You have received:</div>
          <div className={[styles.dialogMessage]}>{toastMessage}</div>

          <div className={[styles.dialogButton, styles.dialogPositiveButton].join(" ")} onClick={() => closeDialog()}>Ok Got it</div>
          <div className={[styles.fontSize12, styles.padding10px, styles.marginT10px].join(" ")}>Amount will be credited to your account within 1minute.</div>
        </div>
      </div>
    </div>
  );
});

export default DialogWinLose;